import { render, staticRenderFns } from "./AdditionCard.vue?vue&type=template&id=2342df03&scoped=true"
import script from "./AdditionCard.vue?vue&type=script&lang=js"
export * from "./AdditionCard.vue?vue&type=script&lang=js"
import style0 from "./AdditionCard.vue?vue&type=style&index=0&id=2342df03&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2342df03",
  null
  
)

export default component.exports